<template>
  <div @click.self="close" class="mask" v-if="state.isVisible">
    <div class="login-modal-content">
      <div class="close-btn">
        <img @click="close" src="@assets/images/close1.png" alt="">
      </div>
      <div class="logo">
        <img src="@assets/images/log.jpg" alt="">
      </div>

      <div class="sign-type">
        <span v-for="x in state.signTypeList" @click="changeSignType(x.signType)"
          :class="{'active': state.signType == x.signType}">
          {{x.name}}
        </span>
      </div>

      <div class="login-input">
        <div class="my-input-box">
          <span class="input-label">
            用户名
          </span>
          <input @input="set" v-model="state.username" placeholder="请输入" type="text" />
        </div>
        <div class="my-input-box">
          <span class="input-label">
            密码
          </span>
          <input @input="set" v-model="state.password" placeholder="请输入" type="text" />
        </div>
        <div v-if="state.signType == 'signup'">
          <div class="my-input-box">
            <span class="input-label" style="font-size: 12px">
              手机或邮箱
            </span>
            <input @input="set" v-model="state.phoneOrEmail" placeholder="请输入" type="text" />
          </div>
          <div class="my-input-box" style="position: relative;">
            <span>
              <!-- 验证码 -->
            </span>
            <input @input="set" v-model="state.verifyCode" placeholder="请输入" type="text" />
            <div style="position: absolute;right: 8px;top: 5px">
              <CountDown ref="countDownRef" @sendVerifyCode="sendVerifyCode"></CountDown>
            </div>
          </div>
        </div>




        <div class="err-msg" v-if="state.errMsg">
          {{ state.errMsg }}
        </div>
        <div class="flex flex-center-start agree">
          <el-checkbox v-model="state.agreen"></el-checkbox>
          <p style="margin-left: 5px;">我已阅读并同意<span @click="showAgreen" style="color: blue;cursor: pointer;">用户协议</span>
          </p>
        </div>

        <div>
          <el-button v-if="state.signType == 'login'" @click="login" type="primary" class="login-btn">登录</el-button>
          <el-button v-else @click="signUp" type="primary" class="login-btn">注册</el-button>


        </div>
        <!-- <div class="login-test">
          登录
        </div> -->
      </div>

    </div>

    <div class="agree-modal-content" v-if="state.agreeShow">
      <div class="close-btn">
        <img @click="closeAgreen" src="@assets/images/close1.png" alt="">
      </div>
      <h3 style="text-align: center;">用户协议</h3>
      <div class="agree-text">
        文本内容
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>
        <p>wenben</p>

      </div>
      <el-button @click="confirmAgree" type="primary" class="login-btn">确定同意</el-button>

    </div>
  </div>

</template>

<script setup>
import { reactive, ref, watch, onMounted, inject, nextTick, isVNode } from 'vue'
import { isEmail, isPhoneNumber } from '../utils'
import CountDown from '@components/countDown.vue'
// const $axios = inject('$axios')

import { request as $axios } from '@utils/axios'


const countDownRef = ref()

const state = reactive({
  username: '',
  password: '',
  phoneOrEmail: '',
  verifyCode: '',
  verifyCodeFromPhone: false,
  agreen: false,
  agreeShow: false,
  isVisible: false,
  errMsg: '',
  signType: 'login',
  signTypeList: [
    { name: '登录', signType: 'login' },
    { name: '注册', signType: 'signup' },

  ]
})

const confirmAgree = () => {
  state.agreen = true
  state.agreeShow = false
}
const changeSignType = (signType) => {
  state.signType = signType
}

const set = (e) => {
  console.log(state.username)
}

const show = () => {
  state.isVisible = true;
}

const close = () => {
  state.isVisible = false;
}

const showAgreen = () => {
  state.agreeShow = true
}

const closeAgreen = () => {
  state.agreeShow = false
}

const sendVerifyCode = async () => {
  if (!state.phoneOrEmail) {
    ElMessage.warning('请先填写手机/邮箱信息')
    return
  }

  const url = '/proxyApi/systemUsers/verifyCode'
  const phone = isPhoneNumber(state.phoneOrEmail)
  const params = {
    emailOrPhone: state.phoneOrEmail,
    phone
  }
  countDownRef.value.startCountdown()

  const res = await $axios.post(url, params)

  if (res.code == 0) {
    // countDownRef.value.startCountdown()
    console.log(res)
  }
}

const checkUserPwd = () => {
  if (!state.password || !state.username) {
    ElMessage.warning('请先填写用户名和密码')
    // return
    throw 'data miss'
  }
}

const signUp = async () => {
  const url = '/proxyApi/systemUsers/register'
  const verifyCodeFromPhone = !(isEmail(state.phoneOrEmail))
  const params = {
    password: state.password,
    username: state.username,
    verifyCode: state.verifyCode,
    verifyCodeFromPhone
  }

  if (verifyCodeFromPhone) {
    params.phone = state.phoneOrEmail
  } else {
    params.email = state.phoneOrEmail
  }

  const res = await $axios.post(url, params)
  if (res.code == 0) {
    console.log(res)
  }
}
const login = async () => {
  checkUserPwd()

  if (!state.agreen) {
    ElMessage.warning('请先阅读并同意用户协议')
    showAgreen()
  }
  const url = `/proxyApi​/systemUsers​/login`
  const params = {
    username: state.username,
    password: state.password
  }
  const res = await $axios.post(url, params)


  if (res.code == 0) {
    console.log(res)
  }
  // state.errMsg = '缺少接口'
}
defineExpose({
  show,
  close
})
</script>

<style lang="scss" scoped>
.sign-type {
  width: 260px;
  margin: 0 auto;
  span {
    color: rgba(0,0,0,0.25);
    cursor: pointer;
    border-bottom: 2px solid transparent;
    padding-bottom: 5px;
    margin-right: 15px;
    &.active {
      color: #06f;
      border-color: #06f;
    }
  }
}
.mask {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  background-color: rgba(0,0,0,0.4);
  z-index: 20;
}
.agree-modal-content {
  background-color: #fff;
  width: 360px;
  height: 360px;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 12px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 22;
  .agree-text {
    // background-color: red;
    height: 260px;
    box-sizing: border-box;
    overflow: auto;
  }
  .login-btn {
    width: 100%;
    font-size: 12px;
    // height: 24px;
    background: linear-gradient(63deg,#5c9ded,#06f);

    margin-top: 15px;
  }
  .close-btn {
    width: 14px;
    height: 14px;
    position: absolute;
    right: 14px;
    top: 10px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
.login-modal-content {
  background-color: #fff;
  width: 360px;
  min-height: 360px;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 12px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .logo {
    width: 240px;
    height: 100px;
    // background-color: #727272;
    margin: 18px auto 0px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .close-btn {
    width: 14px;
    height: 14px;
    position: absolute;
    right: 14px;
    top: 10px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login-input {
    width: 260px;
    padding: 10px 12px;
    margin: 0 auto;
    .my-input-box {
      margin-top: 10px;
      display: flex;
      padding: 10px 10px;
      input {
        font-size: 14px;
      }
      input::placeholder {
        font-size: 14px;
        /* 这里可以根据需求修改具体的字号大小，单位可以是px、em、rem等 */
      }
      .input-label {
        min-width: 60px;
        display: inline-block;
        // text-align-last: justify;
        text-align-last: left;
        color: rgba(0,0,0,0.6);
        padding-right: 5px;
        font-weight: bold;
        margin-right: 10px;
        border-right: 1px solid rgba(0,0,0,0.2);
        font-size: 14px;
      }
    }
  }
  .login-test {
    width: 200px;
    background-color: red;
    color: #fff;
    font-size: 20px;
    letter-spacing: 20px;
  }
  .login-btn {
    width: 100%;
    // height: 24px;
    background: linear-gradient(63deg,#5c9ded,#06f);

    margin-top: 15px;
    height: 40px;
    font-size: 20px;
    border-radius: 20px;
      letter-spacing: 10px;
      text-indent: 5px;
  }
}
.agree {
  font-size: 12px;
}
.err-msg {
  color: red;
  font-size: 12px;
  margin-bottom: 20px;
  margin-top: 5px;
}

</style>